import {
  apiClient,
  type PageEntity,
  type TariffImportJobExEntity
} from '@/libs/api'
import { type TariffImportJobsRequestQuery } from '@/libs/api/types'

export type FetchTariffImportJobsQuery = {
  tenantKey: string
  query: TariffImportJobsRequestQuery
}

export type FetchTariffImportJobsResponse = {
  data: TariffImportJobExEntity[]
  pagination: PageEntity | null
}

export const fetchTariffImportJobs = async (
  { tenantKey, query }: FetchTariffImportJobsQuery,
  signal?: AbortSignal
): Promise<FetchTariffImportJobsResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .tariffs.tariff_import_jobs.$get({
      query,
      config: {
        signal
      }
    })
  return {
    data,
    pagination
  }
}
